import { useState } from "react";
import { Aviso, Botao } from "../ui";
import { copiarTexto } from "../../nucleo/automacao";

/** O valor que só aparece agora: segredo de webhook ou token de API. Fechar o aviso o descarta. */
export function SegredoMostradoUmaVez({
  titulo,
  valor,
  rotuloDoBotao,
  aoFechar,
  "data-testid": testid,
}: {
  titulo: string;
  valor: string;
  rotuloDoBotao: string;
  aoFechar: () => void;
  "data-testid": string;
}) {
  const [copiado, setCopiado] = useState<boolean | null>(null);
  return (
    <Aviso tom="atencao" className="mb-4" data-testid={testid}>
      <p>
        <strong>{titulo}</strong>
      </p>
      <p className="nota-rodape">Guarde agora: este valor não será mostrado de novo.</p>
      <code className="texto-preservado" data-testid={`${testid}-valor`}>
        {valor}
      </code>
      <div className="flex gap-2 mt-2">
        <Botao type="button" variante="fantasma" onClick={() => void copiarTexto(valor).then(setCopiado)}>
          {rotuloDoBotao}
        </Botao>
        <Botao type="button" variante="fantasma" onClick={aoFechar}>
          Já guardei
        </Botao>
      </div>
      {copiado === true ? <p role="status">Copiado.</p> : null}
      {copiado === false ? <p role="status">Não deu para copiar sozinho: selecione e copie o texto acima.</p> : null}
    </Aviso>
  );
}
